import { captureProviderMessagingCredential } from './api';

const SESSION_KEY = 'sw:messagingCredCapturedAt';
/** Re-capture at most once per browser session hour (token rotation / new logins). */
const CAPTURE_TTL_MS = 60 * 60 * 1000;

/**
 * Best-effort capture of the provider Marketplace refresh token for welcome messages.
 * Safe to call often — throttled client-side; server upsert is idempotent.
 * Never throws; failures are silent so login / page load never depend on messaging.
 */
export const ensureMessagingCredentialCaptured = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    const stamped = raw ? Number(raw) : 0;
    if (Number.isFinite(stamped) && Date.now() - stamped < CAPTURE_TTL_MS) {
      return Promise.resolve();
    }
  } catch (e) {
    // Private mode / blocked storage — still attempt capture.
  }

  return captureProviderMessagingCredential()
    .then(() => {
      try {
        sessionStorage.setItem(SESSION_KEY, String(Date.now()));
      } catch (e) {
        // Ignore.
      }
    })
    .catch(() => {
      // API down / not logged in / encryption missing — welcome tab will surface errors on save.
    });
};

/** Force a fresh capture attempt (e.g. after enabling welcome message). */
export const clearMessagingCredentialCaptureThrottle = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch (e) {
    // Ignore.
  }
};
